module.exports = "/assets/data/9eb69c822947aeb554c43f0e86a28ec4-RM1.data.json";